import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {Employers} from "../Models/Employers";
import {environment} from "../../../../environments/environment";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class BeneficiarySimpleGetUtilsService {
  public refund_service_url: string = environment.refund_service_url;
  constructor(private http: HttpClient) { }

  public getAllEmployerNamesAndId(): Observable<Employers[]> {
    return this.http.get<Employers[]>(`${this.refund_service_url}/shared-refund-app/get-all-employers/`)
  }
}
